import { FaWhatsapp } from 'react-icons/fa';

export const WhatsAppIcon = FaWhatsapp;